import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db69d40a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]

import { type PropType, toRefs } from 'vue';

import { useExpandableText } from '@/composables/useExpandableText';

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableText',
  props: {
    text: {
        type: String,
        required: true,
    },
    animationDuration: {
        type: Number,
        default: 200,
    },
    collapseText: {
        type: Function as PropType<(expandedText: string) => string>,
        default: (expandedText: string) => expandedText.charAt(0),
    },
    disableHover: {
        type: Boolean,
        default: false,
    },
    disableExpansion: {
        type: Boolean,
        default: false,
    },
},
  setup(__props, { expose: __expose }) {

const props = __props;


const { text, disableExpansion, collapseText } = toRefs(props);

const { currentText, width, maskActive, isExpanded, container, expand, collapse, animationDuration } =
    useExpandableText(text, {
        disableExpansion: disableExpansion.value,
        animationDuration: props.animationDuration,
        collapseText: collapseText?.value,
    });
function onMouseEnter() {
    if (!props.disableHover) expand();
}
function onMouseLeave() {
    if (!props.disableHover) collapse();
}
__expose({ expand, collapse });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "expandable-text-wrapper",
    style: _normalizeStyle({ width: _unref(width) + 'px', '--animation-duration': _unref(animationDuration) + 'ms' }),
    "aria-label": props.text,
    onMouseenter: onMouseEnter,
    onFocus: onMouseEnter,
    onMouseleave: onMouseLeave,
    onBlur: onMouseLeave
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["expandable-text", {
                'mask-active': _unref(maskActive),
                'is-expanded': _unref(isExpanded),
            }])
    }, _toDisplayString(_unref(currentText)), 3)
  ], 44, _hoisted_1))
}
}

})